export default function Hidden() {
    return null
}
